module.exports = __webpack_public_path__ + "static/media/logo4.eef1a641.png";